/**
 * Numéros de contact plateforme (support / footer / FAQ).
 * Source unique pour l’affichage et les liens tel: / WhatsApp.
 */
export const PLATFORM_PHONES = [
  {
    display: '+228 72 60 33 33',
    tel: '+22872603333',
    whatsapp: '22872603333',
  },
  {
    display: '+228 79 79 02 68',
    tel: '+22879790268',
    whatsapp: '22879790268',
  },
];

/** Lien WhatsApp (numéro principal par défaut). */
export function platformWhatsAppUrl(phoneIndex = 0) {
  const entry = PLATFORM_PHONES[phoneIndex];
  if (!entry) return 'https://wa.me/';
  return `https://wa.me/${entry.whatsapp}`;
}
